var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./analytics", "./assetFilter", "./canvas", "./context", "./customDesign", "./debounce", "./designActions", "./glfx", "./images", "./number", "./jquery-plugins/numberInput", "./priceFormula", "./progress", "./querystring", "./radioList", "./renderCustomValance", "./slideSelect", "./svg", "./until", "./paintColors", "./object", "./modal", "./selectSpinner"], function (require, exports, analytics_1, assetFilter_1, canvas_1, context_1, customDesign_1, debounce_1, designActions_1, glfx_1, images_1, number_1, numberInput_1, priceFormula_1, progress_1, querystring_1, radioList_1, renderCustomValance_1, slideSelect_1, svg_1, until_1, paintColors_1, object_1, modal_1, selectSpinner_1) {
    "use strict";
    exports.__esModule = true;
    ;
    exports.length = function (seg) {
        var dx = seg.start.X - seg.end.X;
        var dy = seg.start.Y - seg.end.Y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    var ProgressFlags;
    (function (ProgressFlags) {
        ProgressFlags[ProgressFlags["position"] = 1] = "position";
        ProgressFlags[ProgressFlags["style"] = 2] = "style";
        ProgressFlags[ProgressFlags["fabric"] = 4] = "fabric";
        ProgressFlags[ProgressFlags["fringe"] = 8] = "fringe";
        ProgressFlags[ProgressFlags["panel"] = 16] = "panel";
        ProgressFlags[ProgressFlags["size"] = 32] = "size";
        ProgressFlags[ProgressFlags["price"] = 64] = "price";
    })(ProgressFlags = exports.ProgressFlags || (exports.ProgressFlags = {}));
    var perspectiveSet = false;
    var formulaApiUrl = null;
    exports.inside = function (box, point) {
        var x = point.X, y = point.Y;
        var topLeft = box.topLeft, size = box.size;
        var left = topLeft.X, top = topLeft.Y;
        var bottom = top + size.Height;
        var right = left + size.Width;
        return left <= x && x <= right && top <= y && y <= bottom;
    };
    exports.bottomRight = function (box) { return ({
        X: box.topLeft.X + box.size.Width,
        Y: box.topLeft.Y + box.size.Height
    }); };
    exports.covers = function (out, inner) { return exports.inside(out, inner.topLeft) && exports.inside(out, exports.bottomRight(inner)); };
    function scaleSize(cur, scale) {
        return {
            Width: cur.Width * scale,
            Height: cur.Height * scale
        };
    }
    exports.scaleSize = scaleSize;
    function fitBoundingBox(cur, bound) {
        var scaleX = bound.Width / cur.Width;
        var scaleY = bound.Height / cur.Height;
        var scale = Math.min(scaleX, scaleY);
        return {
            Width: Math.round(cur.Width * scale),
            Height: Math.round(cur.Height * scale)
        };
    }
    exports.fitBoundingBox = fitBoundingBox;
    function mapToScaledImage(point, size, scale) {
        var center = { X: size.Width / 2, Y: size.Height / 2 };
        return {
            X: (point.X - center.X) * scale + center.X,
            Y: (point.Y - center.Y) * scale + center.Y
        };
    }
    function mapToImageCoordinate($box, point, scale) {
        var svg = $box.find('svg')[0];
        var viewbox = svg.viewBox;
        var img = findPictureElement($box);
        var imgWidth = canvas_1.isImg(img) ? img.naturalWidth : parseInt(img.getAttribute('width'));
        var imgHeight = canvas_1.isImg(img) ? img.naturalHeight : parseInt(img.getAttribute('height'));
        var width = imgWidth || $box.width();
        var height = imgHeight || $box.height();
        var aspect = height / width;
        var boxAspect = viewbox.baseVal.height / viewbox.baseVal.width;
        var x = point.x * width / viewbox.baseVal.width;
        var y = point.y * height / viewbox.baseVal.height;
        if (aspect < boxAspect) {
            x = point.x * height / viewbox.baseVal.height;
        }
        else if (aspect > boxAspect) {
            y = point.y * width / viewbox.baseVal.width;
        }
        var p = mapToScaledImage({ X: x, Y: y }, { Width: width, Height: height }, scale);
        return { X: Math.round(p.X), Y: Math.round(p.Y) };
    }
    function getWindowBoxBoundingScale($svg, scale) {
        if (scale !== 1.0 || $svg.data('rectangular')) {
            return 1.0;
        }
        return 1.2;
    }
    function findPictureElement($box) {
        var $result = $box.find('img:visible, #roomCanvas:visible, #capturedImage:visible');
        if ($result.length === 0) {
            $result = $box.find('img, #roomCanvas, #capturedImage');
        }
        return $result[0];
    }
    function mapToSvgCoordinate($box, point, scale) {
        var $svg = $($box.find('svg')[0]);
        var svg = $box.find('svg')[0];
        var viewbox = svg.viewBox;
        var img = findPictureElement($box);
        var imgWidth = canvas_1.isImg(img) ? img.naturalWidth : parseInt(img.getAttribute('width'));
        var imgHeight = canvas_1.isImg(img) ? img.naturalHeight : parseInt(img.getAttribute('height'));
        var width = imgWidth || $box.width();
        var height = imgHeight || $box.height();
        var aspect = height / width;
        var boxAspect = viewbox.baseVal.height / viewbox.baseVal.width;
        var boxWidth = viewbox.baseVal.width;
        var boxHeight = viewbox.baseVal.height;
        var scaledPoint = mapToScaledImage(point, {
            Width: width,
            Height: height
        }, scale);
        var x = scaledPoint.X * viewbox.baseVal.width / width;
        var y = scaledPoint.Y * viewbox.baseVal.height / height;
        if (aspect < boxAspect) {
            x = scaledPoint.X * viewbox.baseVal.height / height;
            boxWidth = Math.round(boxHeight / aspect);
        }
        else if (aspect > boxAspect) {
            y = scaledPoint.Y * viewbox.baseVal.width / width;
            boxHeight = Math.round(boxWidth * aspect);
        }
        var boundingScale = getWindowBoxBoundingScale($svg, scale);
        var boundingLeft = Math.round(-boxWidth * 0.5 * (boundingScale - 1.0));
        var boundingTop = Math.round(-boxHeight * 0.5 * (boundingScale - 1.0));
        var result = svg_1.keepInBoundingBox({ X: x, Y: y }, {
            topLeft: { X: boundingLeft, Y: boundingTop },
            size: {
                Width: boxWidth * boundingScale,
                Height: boxHeight * boundingScale
            }
        });
        return { x: result.X, y: result.Y };
    }
    function getWindowPositions(polygon, $box) {
        var points = polygon.points;
        var pointCount = points.numberOfItems;
        var result = {};
        var _loop_1 = function (i) {
            var point = points.getItem(i);
            var setter = function (p) {
                switch (i) {
                    case 0:
                        result.topLeft = p;
                        break;
                    case 1:
                        result.bottomLeft = p;
                        break;
                    case 2:
                        result.bottomRight = p;
                        break;
                    case 3:
                        result.topRight = p;
                        break;
                    default:
                }
                ;
            };
            var svg = $(polygon).closest('svg');
            var scale = getWindowBoxScale(svg);
            var point2D = mapToImageCoordinate($box, point, scale);
            setter(point2D);
        };
        for (var i = 0; i < pointCount; i++) {
            _loop_1(i);
        }
        return result;
    }
    exports.getWindowPositions = getWindowPositions;
    function distance(from, to) {
        var dx = from.X - to.X;
        var dy = from.Y - to.Y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    function midPoint(from, to) {
        return { X: (from.X + to.X) / 2, Y: (from.Y + to.Y) / 2 };
    }
    function scalePoint(p, scale) {
        return { X: p.X * scale, Y: p.Y * scale };
    }
    function estimateWindowSize(sketch) {
        var position = sketch.WindowPosition;
        var y1 = midPoint(position.topLeft, position.topRight);
        var y2 = midPoint(position.bottomLeft, position.bottomRight);
        var height = distance(y1, y2);
        var x1 = midPoint(position.topLeft, position.bottomLeft);
        var x2 = midPoint(position.topRight, position.bottomRight);
        var width = distance(x1, x2);
        var normalHeight = sketch.SpecifiedHeight || 96;
        if (sketch.SpecifiedWidth) {
            return {
                Width: sketch.SpecifiedWidth,
                Height: sketch.SpecifiedHeight || Math.round(height * sketch.SpecifiedWidth / (width || 1))
            };
        }
        return {
            Width: Math.round(width * normalHeight / (height || 1)),
            Height: normalHeight
        };
    }
    function shouldShowWindowBox(sketch) {
        return !sketch.ProgressMask || !(sketch.ProgressMask & ProgressFlags.position);
    }
    exports.shouldShowWindowBox = shouldShowWindowBox;
    function getDefaultCurtainSpec(sketch) {
        var size = estimateWindowSize(sketch);
        var productType = sketch.style === 10 ? renderCustomValance_1.ProductType.DrapeOnly : (sketch.productType || renderCustomValance_1.ProductTypes.FullSet);
        var panelHeading = productType === renderCustomValance_1.ProductTypes.ValanceOnly ? undefined :
            (isNaN(sketch.panelHeading) ? 0 : sketch.panelHeading);
        return {
            productType: productType,
            style: sketch.style || 1,
            width: sketch.SpecifiedWidth || sketch.width || size.Width,
            height: sketch.SpecifiedHeight || sketch.height || size.Height,
            fabricMain: renderCustomValance_1.getFabricNameFromCodeName("" + (sketch.fabricMain || renderCustomValance_1.SKETCH_FABRIC_CODE)),
            fabricId: sketch.fabricId,
            fringeStyle: sketch.fringeStyle || 0,
            panelHeading: panelHeading,
            withSheers: false
        };
    }
    exports.getDefaultCurtainSpec = getDefaultCurtainSpec;
    function showCurtainOnSketch(sketch, img) {
        var spec = getDefaultCurtainSpec(sketch);
        var pos = __assign({}, sketch.WindowPosition);
        var $img = $(img);
        if (!$img.is(':visible')) {
            $img = $img.prev('#roomCanvas');
        }
        var box = {
            Width: $img.width(),
            Height: $img.height()
        };
        var imageSize = {
            Width: img.naturalWidth || parseInt($img.attr('width')),
            Height: img.naturalHeight || parseInt($img.attr('height'))
        };
        var scale = box.Width / imageSize.Width;
        pos.topLeft = scalePoint(pos.topLeft, scale);
        pos.topRight = scalePoint(pos.topRight, scale);
        pos.bottomLeft = scalePoint(pos.bottomLeft, scale);
        pos.bottomRight = scalePoint(pos.bottomRight, scale);
        ensurePerspectiveSet();
        return renderCustomValance_1.placeCurtainOnDesignSketch(box, spec, false, !sketch.RootSketchId, pos.topLeft.X, pos.topLeft.Y, pos.topRight.X, pos.topRight.Y, pos.bottomLeft.X, pos.bottomLeft.Y, pos.bottomRight.X, pos.bottomRight.Y);
    }
    exports.showCurtainOnSketch = showCurtainOnSketch;
    function toggleStyle(img, sketch, on) {
        var $img = $(img);
        var $prevCanvas = $img.nextAll('.canvas-box');
        var toShow = $prevCanvas.length === 0;
        if (on !== undefined) {
            toShow = on;
        }
        if (!toShow) {
            $prevCanvas.remove();
        }
        else {
            showCurtainOnSketch(sketch, img).then(function (canvas) {
                var cur = $('<div class="canvas-box"></div>').append($(canvas)).insertAfter($img);
                cur.nextAll('.canvas-box').remove();
            });
        }
    }
    exports.toggleStyle = toggleStyle;
    function updatePricing(sketch) {
        computeDesignSketchPricing(sketch).then(function (pricing) {
            if (pricing) {
                customDesign_1.displayPriceInfo(pricing, sketch.productType, $('#design_show_price'));
                customDesign_1.displayPriceInfo(pricing, sketch.productType, $('#design_show_summary'));
            }
            $('#design_show_price').toggleClass('hidden', !pricing);
        });
    }
    function updateStyle(img, sketch) {
        var $img = $(img);
        var $prevCanvas = $img.nextAll('.canvas-box');
        var $svg = $img.nextAll('svg');
        if (sketch.style === 10) {
            sketch.productType = renderCustomValance_1.ProductType.DrapeOnly;
        }
        else if (sketch.productType === renderCustomValance_1.ProductType.DrapeOnly) {
            var $product = $('#design_product_select .option.selected');
            sketch.productType = Number($product.data('decimal')) || renderCustomValance_1.ProductType.FullSet;
        }
        if ($svg.length) {
            $svg.trigger('resize');
        }
        else {
            console.warn('svg not found');
        }
        var result = showCurtainOnSketch(sketch, img).then(function (canvas) {
            if ($prevCanvas.length) {
                $prevCanvas.remove();
            }
            $('<div class="canvas-box"></div>').append($(canvas)).insertAfter($img).next('.canvas-box').remove();
        });
        updatePricing(sketch);
        return result;
    }
    function handleDesignChange(img, sketch, aspect) {
        var action = aspect === 'style' ? designActions_1.DesignCenterActions.edit.style.select :
            aspect === 'fabric' ? designActions_1.DesignCenterActions.edit.fabric.select : '';
        if (action) {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, action);
        }
        updateStyle(img, sketch);
    }
    exports.handleDesignChange = handleDesignChange;
    function isDesignSketchQuotable(sketch) {
        var validStyle = (!!sketch.style) || (!!(sketch.ProgressMask & ProgressFlags.style));
        return validStyle && !!sketch.fabricId;
    }
    function getSpecFabricGrade(spec) {
        var fabricGrade = $('#design_fabric_select').find("li[data-decimal=\"" + spec.fabricId + "\"]").data('grade');
        return Number(fabricGrade);
    }
    function getSelectedStyle(spec) {
        return $('#design_style_select').find("li[data-decimal=\"" + spec.style + "\"]");
    }
    function getSelectedFabric(spec) {
        return $('#design_fabric_select').find("li[data-decimal=\"" + spec.fabricId + "\"]");
    }
    function getSelectedFringe(spec) {
        return $('#design_fringe_select').find("li[data-tags*=\"fringeStyle_" + spec.fringeStyle + ",\"],li[data-tags$=\"fringeStyle_" + spec.fringeStyle + "\"]");
    }
    function getSelectedProductName(spec) {
        switch (spec.productType) {
            case renderCustomValance_1.ProductType.DrapeOnly:
                return 'One panel';
            case renderCustomValance_1.ProductType.FullSet:
                return 'Swag valance + 2 panels';
            case renderCustomValance_1.ProductType.ValanceOnly:
                return 'Swag valance only';
        }
    }
    function computeDesignSketchPricing(sketch) {
        var quotable = isDesignSketchQuotable(sketch);
        if (!quotable) {
            return $.Deferred().resolve(null);
        }
        var spec = getDefaultCurtainSpec(sketch);
        var formulaName = getSelectedStyle(spec).data('formula');
        var fabricGrade = getSpecFabricGrade(spec);
        var hasFringe = spec.fringeStyle !== 0 ? 1 : 0;
        var data = $.extend({}, spec, { hasFringe: hasFringe, fabricGrade: fabricGrade, fabricCodeName: spec.fabricMain });
        return priceFormula_1.computeFormulaPricing(formulaApiUrl, formulaName, data);
    }
    function getWindowBoxScale($svg, override) {
        return !override && !$svg.closest('.img-box').hasClass('position') && ($svg.data('rectangular') || $svg.attr('class').indexOf('hidden') >= 0) ? 1 : 1.2;
    }
    function setWindowCorner($corner, $box, point, withScale, useScale) {
        var box = $box.find('polygon#window-box')[0];
        var corner = $corner[0];
        var svg = $corner.closest('svg');
        var scale = useScale || (1 / getWindowBoxScale(svg, withScale));
        var svgPoint = mapToSvgCoordinate($box, point, scale);
        svg_1.moveBoxCorner(box, corner, svgPoint);
    }
    function getCurrentWindowPosition(parentSelector, $box) {
        if (parentSelector === void 0) { parentSelector = ''; }
        $box = $box || $(parentSelector + " .current.img-box");
        if ($box.length !== 1) {
            $box = $($(parentSelector + " .img-box")[0]);
        }
        var polygon = $box.find('polygon#window-box')[0];
        return getWindowPositions(polygon, $box);
    }
    function getRectangleWidth(position) {
        return Math.abs(position.topLeft.X - position.topRight.X);
    }
    function getRectangleHeight(position) {
        return Math.abs(position.topLeft.Y - position.bottomLeft.Y);
    }
    function getRectangleLeft(position) {
        return Math.min(position.topLeft.X, position.topRight.X);
    }
    function getRectangleRight(position) {
        return Math.max(position.topLeft.X, position.topRight.X);
    }
    function getRectangleTop(position) {
        return Math.min(position.topLeft.Y, position.bottomLeft.Y);
    }
    function getRectangleBottom(position) {
        return Math.max(position.topLeft.Y, position.bottomLeft.Y);
    }
    function findSelectedOption($container, val) {
        return $container.find("li[data-decimal=\"" + val + "\"]");
    }
    function getSelectedTags($option) {
        return $option.data('tags').split(',');
    }
    function parseTagAsNumber(tags, prefix) {
        var filtered = tags.filter(function (x) { return x.indexOf(prefix) === 0; });
        var tag = filtered.length ? filtered[0] : null;
        return tag ? parseInt(tag.substr(prefix.length)) : NaN;
    }
    function prevSel($cur, sel) {
        var $result = $cur.prev(sel);
        return $result.length ? $result : $cur.prevUntil(sel).prev();
    }
    function bindWindowPosition($svg, sketch) {
        $svg.off('resize resize:start resize:end').resize(function (e) {
            sketch.WindowPosition = getCurrentWindowPosition(".edit-design-sketch");
        });
        $svg
            .on('resize:start', function (e, sel) {
            sketch.width = sketch.height = undefined;
            $svg.data('active', sel);
            var $img = $svg.prevAll('img, #capturedImage');
            var img = $img[0];
            toggleStyle(img, sketch, false);
        })
            .on('resize:end', function () {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.position.drag);
            var $img = $svg.prevAll('img, #capturedImage');
            if (!$img.length) {
                return;
            }
            var img = $img[0];
            toggleStyle(img, sketch, true);
            var size = estimateWindowSize(sketch);
            sketch.width = sketch.SpecifiedWidth || size.Width;
            sketch.height = sketch.SpecifiedHeight || size.Height;
            computeDesignSketchPricing(sketch).then(function (pricing) {
                if (pricing) {
                    customDesign_1.displayPriceInfo(pricing, sketch.productType, $('#design_show_price'));
                    customDesign_1.displayPriceInfo(pricing, sketch.productType, $('#design_show_summary'));
                }
                $('#design_show_price').toggleClass('hidden', !pricing);
            });
        });
    }
    exports.bindWindowPosition = bindWindowPosition;
    var missingFieldDisplayNames = {
        SpecifiedWidth: 'width',
        SpecifiedHeight: 'height'
    };
    function missingSizeTip(sketch) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        var missingKeys = keys.filter(function (key) { return !sketch[key]; }).map(function (k) { return missingFieldDisplayNames[k]; });
        return missingKeys.join(',');
    }
    function updateSizeTip($tip, sketch) {
        var missingSizes = missingSizeTip(sketch, 'SpecifiedWidth', 'SpecifiedHeight');
        var prompt = missingSizes ? " (please specify " + missingSizes + ")" : '';
        $tip.text("Measurements " + prompt);
    }
    var panelCount = function (spec) {
        switch (spec.productType) {
            case renderCustomValance_1.ProductType.FullSet:
                return 2;
            case renderCustomValance_1.ProductType.DrapeOnly:
                return 1;
            default:
                return 0;
        }
    };
    function getSpecDetailsText(spec, key) {
        var _a;
        var panelWidth = Math.min((spec.style === 10) ? 35 : 100, spec.width);
        var panels = panelCount(spec);
        var tiebacks = [
            '',
            '1 matching fabric tieback',
            '2 matching fabric tiebacks'
        ];
        var field = function (x) { return getSpecDetailsText(spec, x); };
        var products = (_a = {},
            _a[renderCustomValance_1.ProductType.FullSet] = function () { return ["1 valance, " + field('valanceSize') + ".", "2 panels, " + field('panelSize') + ".", field('fit') + ".", field('tieback') + "."]; },
            _a[renderCustomValance_1.ProductType.ValanceOnly] = function () { return ["1 valance, " + field('valanceSize') + ".", field('fit') + "."]; },
            _a[renderCustomValance_1.ProductType.DrapeOnly] = function () { return ["1 panel, " + field('panelSize') + ".", field('tieback') + "}"]; },
            _a);
        var hasValance = spec.productType === renderCustomValance_1.ProductType.ValanceOnly || spec.productType === renderCustomValance_1.ProductType.FullSet;
        var hasFringe = hasValance && !!spec.fringeStyle;
        if (spec.productType !== renderCustomValance_1.ProductType.DrapeOnly && spec.productType !== renderCustomValance_1.ProductType.FullSet && spec.productType !== renderCustomValance_1.ProductType.ValanceOnly) {
            throw new Error("unsupported producType " + spec.productType);
        }
        var $fringe = $("li[data-tags^=\"fringeStyle_" + spec.fringeStyle + "\"]");
        switch (key) {
            case 'valanceSize':
                return spec.width + "\" wide, fully lined, rod pocket";
            case 'panelSize':
                return panelWidth + "\" W x " + spec.height + "\" H, fully lined, rod pocket";
            case 'tieback':
                return tiebacks[panels];
            case 'fit':
                return hasValance ? "Best fits window up to " + (spec.width - (spec.productType === renderCustomValance_1.ProductType.FullSet ? 10 : 4)) + "\" wide" : '';
            case 'fringe':
                return hasFringe ? $fringe.text().trim() : null;
            case 'product':
                return products[spec.productType]();
        }
    }
    exports.getSpecDetailsText = getSpecDetailsText;
    function fillDesignSummary(sketch, $summary) {
        var spec = getDefaultCurtainSpec(sketch);
        var $style = getSelectedStyle(spec);
        var styleName = $style.find('label').text();
        $summary.find('td[data-field="style"]').text(styleName);
        var $fabric = getSelectedFabric(spec);
        var fabricName = $fabric.find('label').text();
        $summary.find('td[data-field="fabric"]').text(fabricName);
        $summary.find('td[data-field="product"]').text(getSelectedProductName(spec));
        var $fringe = getSelectedFringe(spec);
        var fringeName = $fringe.find('label').text();
        $summary.find('td[data-field="fringe"]').text(fringeName);
        var fringeMask = $style.data('fringemask').split(',');
        $summary.find('td[data-field="fringe"]').closest('tr').toggleClass('hidden', fringeMask.length === 0);
        var productType = spec.productType;
        var hasValance = productType === renderCustomValance_1.ProductType.FullSet || productType === renderCustomValance_1.ProductType.ValanceOnly;
        var hasPanel = productType === renderCustomValance_1.ProductType.FullSet || productType === renderCustomValance_1.ProductType.DrapeOnly;
        var $valanceSize = $summary.find('td[data-field="valance-size"]');
        var $panelSize = $summary.find('td[data-field="panel-size"]');
        var panelWidth = Math.min((spec.style === 10) ? 35 : 100, spec.width);
        $valanceSize.text(getSpecDetailsText(spec, 'valanceSize'));
        $panelSize.text(getSpecDetailsText(spec, 'panelSize'));
        $valanceSize.closest('tr').toggleClass('hidden', !hasValance);
        $panelSize.closest('tr').toggleClass('hidden', !hasPanel);
        var hasFitInfo = spec.productType === renderCustomValance_1.ProductType.ValanceOnly || spec.productType === renderCustomValance_1.ProductType.FullSet;
        if (hasFitInfo) {
            $summary.find('td[data-field="fit"]').text(getSpecDetailsText(spec, 'fit'));
            $summary.find('td[data-field="fit"]').closest('tr').toggleClass('hidden', !hasFitInfo);
        }
        if (sketch.SpecifiedWidth && sketch.SpecifiedHeight) {
            $summary.find('.missing-size').toggleClass('hidden', true);
            $summary.find('.hidden-missing-size').toggleClass('hidden', false);
        }
        else {
            $summary.find('.missing-size').toggleClass('hidden', false);
            $summary.find('.hidden-missing-size').toggleClass('hidden', true);
        }
        var hasExtra = spec.productType !== renderCustomValance_1.ProductType.ValanceOnly;
        if (hasExtra) {
            var extra = spec.productType === renderCustomValance_1.ProductType.FullSet ? "2 matching fabric tiebacks" : "1 matching fabric tieback";
            $summary.find('td[data-field="extra"]').text(extra);
        }
        $summary.find('td[data-field="extra"]').closest('tr').toggleClass('hidden', !hasExtra);
    }
    function bindCurtainPrice(sketch, $price) {
        var $summary = $price.next('#design_show_summary');
        $price.unbind('click').click(debounce_1["default"](function () {
            var toOpen = $summary.hasClass('closed');
            analytics_1["default"](designActions_1.DesignCenterActions.ns, toOpen ? designActions_1.DesignCenterActions.edit.summary.show : designActions_1.DesignCenterActions.edit.summary.hide);
            if (toOpen) {
                fillDesignSummary(sketch, $summary);
                showDesignSummary();
            }
            else {
                hideDesignSummary();
            }
        }, 400, true));
        $summary.find('.missing-size a').unbind('click').click(debounce_1["default"](function () {
            radioList_1.radioCurrent('detail-bar', 'size');
        }, 400, true));
    }
    function bindCurtainSize(img, $form, sketch) {
        var $width = $form.find('#design_width');
        var $height = $form.find('#design_height');
        var $tip = $form.find('.design-size-tip');
        var showSizeMark = function (mark, show) {
            var $svg = $('#edit-sketch-window-box-svg');
            svg_1.toggleSizeMark($svg, mark, show);
        };
        var $editForm = $form.closest('.edit-form');
        var $editor = $editForm.closest('.sketch-edit');
        var $imgBox = $editForm.closest('.edit-design-sketch').find('.img-box');
        var layoutHandler = selectSpinner_1.layoutSpinner($editForm, $imgBox[0]);
        var $widthFocus = $width.attr('type') === 'hidden' ? $('#edit_design_width') : $width;
        var $heightFocus = $height.attr('type') === 'hidden' ? $('#edit_design_height') : $height;
        var roomCanvas = $editor.find('#roomCanvas')[0];
        $width.off('change').on('change', function (e) {
            numberInput_1.validateNumberRange($(e.currentTarget));
            if (numberInput_1.isValidNumberField($width)) {
                analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.size.width);
                sketch.SpecifiedWidth = number_1.valAsNumber($width.val());
                if (!isRootSketch(sketch)) {
                    updateStyle(img, sketch);
                }
                else {
                    var canvas = $editor.find('#roomCanvas')[0];
                    var spec_1 = resizeWindowForCurtainSize(canvas, __assign({}, sketch, { width: sketch.SpecifiedWidth, height: sketch.SpecifiedHeight || 102.6 }));
                    updateRoomCanvas(roomCanvas, function () { return spec_1; });
                    var wpos = resizeWindowPositions(spec_1, canvas);
                    _designer.resizeWindow(wpos);
                }
            }
        });
        if ($widthFocus.attr('type') === 'number') {
            $widthFocus.off('change').on('change', function (e) {
                var val = $widthFocus.val();
                $("#" + $widthFocus.data('sync')).val(val).data('decimal', val).trigger('change');
            });
        }
        $widthFocus.off('focus').on('focus', function (e) {
            $tip.text('Width of the window treatments');
            showSizeMark('height', false);
            showSizeMark('width', true);
            layoutHandler.focus();
        }).off('blur').on('blur', function (e) {
            updateSizeTip($tip, sketch);
            showSizeMark('width', false);
            layoutHandler.blur();
        });
        $height.off('change').on('change', function (e) {
            numberInput_1.validateNumberRange($(e.currentTarget));
            if (numberInput_1.isValidNumberField($height)) {
                analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.size.height);
                sketch.SpecifiedHeight = number_1.valAsNumber($height.val());
                if (!isRootSketch(sketch)) {
                    updateStyle(img, sketch);
                }
                else {
                    var canvas = $editor.find('#roomCanvas')[0];
                    var spec_2 = resizeWindowForCurtainSize(canvas, __assign({}, sketch, { width: sketch.SpecifiedWidth || 92, height: sketch.SpecifiedHeight }));
                    updateRoomCanvas(roomCanvas, function () { return spec_2; });
                    var wpos = resizeWindowPositions(spec_2, canvas);
                    _designer.resizeWindow(wpos);
                }
            }
        });
        if ($heightFocus.attr('type') === 'number') {
            $heightFocus.off('change').on('change', function (e) {
                var val = $heightFocus.val();
                $("#" + $heightFocus.data('sync')).val(val).data('decimal', val).trigger('change');
            });
        }
        $heightFocus.off('focus').on('focus', function (e) {
            $tip.text('Height');
            showSizeMark('width', false);
            showSizeMark('height', true);
            layoutHandler.focus();
        }).off('blur').on('blur', function (e) {
            updateSizeTip($tip, sketch);
            showSizeMark('height', false);
            layoutHandler.blur();
        });
        var $marks = $('input[name="designSizeEdit"]');
        $marks.off('change').on('change', function (e) {
            var val = $marks.filter(':checked').val();
            if (val === 'design_width') {
                $tip.text('Width of the window treatments');
                showSizeMark('width', true);
                showSizeMark('height', false);
            }
            if (val === 'design_height') {
                $tip.text('Overall Height');
                showSizeMark('width', false);
                showSizeMark('height', true);
            }
        });
        updateSizeTip($tip, sketch);
    }
    function handleProductTypeChange(sketch) {
        var $targets = $('[data-exceptProductType]');
        var productType = sketch.productType;
        $targets.each(function (i, t) {
            var $target = $(t);
            var productTypeName = $target.data('exceptProductType') || $target.data('exceptproducttype');
            var exceptProductType = renderCustomValance_1.ProductType[productTypeName];
            $target.toggleClass('hidden', exceptProductType === productType);
        });
    }
    exports.handleProductTypeChange = handleProductTypeChange;
    function setWindowPosition($svg, $box, position, withScale, scale) {
        setWindowCorner($svg.find('use.point-handle[data-index="0"]'), $box, position.topLeft, withScale, scale);
        setWindowCorner($svg.find('use.point-handle[data-index="1"]'), $box, position.bottomLeft, withScale, scale);
        setWindowCorner($svg.find('use.point-handle[data-index="2"]'), $box, position.bottomRight, withScale, scale);
        setWindowCorner($svg.find('use.point-handle[data-index="3"]'), $box, position.topRight, withScale, scale);
        svg_1.syncSizeSegments($svg);
    }
    exports.setWindowPosition = setWindowPosition;
    function setDefaultWindowPosition($svg, $box, photoSize, spec) {
        var left = Math.round(photoSize.Width / 4);
        var right = photoSize.Width - left;
        var top = Math.round(photoSize.Height / 4);
        var bottom = photoSize.Height - top;
        if (spec) {
            var windowWidth = spec.windowWidth, windowHeight = spec.windowHeight, windowBottom2Floor = spec.windowBottom2Floor, windowTop2Ceiling = spec.windowTop2Ceiling, height = spec.maxHeight, width = spec.maxWidth;
            var wallHeight = windowHeight + windowBottom2Floor + windowTop2Ceiling;
            var xScale = photoSize.Width / width;
            var yScale = photoSize.Height / height;
            var xGap = Math.round(Math.max(0, xScale * (width - windowWidth) / 2));
            left = xGap;
            right = photoSize.Width - xGap;
            top = Math.round(Math.max(0, yScale * ((height - wallHeight) * .4 + windowTop2Ceiling)));
            bottom = Math.round(Math.min(photoSize.Height, top + yScale * windowHeight));
        }
        var pos = {
            topLeft: { X: left, Y: top },
            topRight: { X: right, Y: top },
            bottomLeft: { X: left, Y: bottom },
            bottomRight: { X: right, Y: bottom }
        };
        setWindowPosition($svg, $box, pos);
    }
    exports.setDefaultWindowPosition = setDefaultWindowPosition;
    function afterImageReady($img, next) {
        var img = $img[0];
        until_1["default"](function () { return img && img.complete && img.naturalHeight > 0 && img.naturalWidth > 0; })
            .then(next);
    }
    exports.afterImageReady = afterImageReady;
    function handleFringeChange($fringes, fringeId, sketch, img) {
        var $fringe = findSelectedOption($fringes, fringeId);
        var fringeTags = getSelectedTags($fringe);
        var fringeStyle = parseTagAsNumber(fringeTags, 'fringeStyle_');
        if (!isNaN(fringeStyle)) {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.fringe.select);
            sketch.fringeStyle = fringeStyle;
            updateStyle(img, sketch);
        }
    }
    exports.handleFringeChange = handleFringeChange;
    function navigateToDesignSketch(sketch) {
        var url = "/Design/edit/" + sketch.Id;
        progress_1.setState({
            visibility: 'visible',
            className: '',
            label: 'Saving...'
        });
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html'
        }).then(function (html) {
            progress_1.setState({
                visibility: 'hidden',
                className: '',
                label: 'Open...'
            });
            window.location.href = url;
        }).always(function () {
            progress_1.setState({
                visibility: 'hidden',
                className: '',
                label: '...'
            });
        });
    }
    exports.navigateToDesignSketch = navigateToDesignSketch;
    function handlePanelChange($panels, panelId, sketch, img) {
        var $panel = findSelectedOption($panels, panelId);
        var panelTags = getSelectedTags($panel);
        var panelStyle = parseTagAsNumber(panelTags, 'panelStyle_');
        if (!isNaN(panelStyle)) {
            sketch.productType = panelStyle ? renderCustomValance_1.ProductTypes.FullSet : renderCustomValance_1.ProductTypes.ValanceOnly;
            if (sketch.productType !== renderCustomValance_1.ProductTypes.ValanceOnly) {
                sketch.panelHeading = parseTagAsNumber(panelTags, 'panelHeading_');
            }
            handleProductTypeChange(sketch);
            updateStyle(img, sketch);
        }
    }
    exports.handlePanelChange = handlePanelChange;
    function getDesignThumbnail($box) {
        var $img = $box.find('>img:visible, #roomCanvas:visible');
        var $canvas = $img.nextAll('.canvas-box').find('canvas');
        var img = $img[0];
        var canvas = $canvas[0];
        var composed = canvas_1.isImg(img) ? canvas_1.composeImageAsBackground(img, canvas) : canvas_1.composeCanvasAsBackground(img, canvas);
        var thumbnail = canvas_1.scalePicture(composed, images_1.ThumbSize.Width, images_1.ThumbSize.Height);
        var result = $.Deferred();
        result.resolve(thumbnail);
        return result;
    }
    function maskToFlags(mask) {
        var progress = [];
        if (mask & ProgressFlags.position) {
            progress.push('position');
        }
        if (mask & ProgressFlags.style) {
            progress.push('style');
        }
        if (mask & ProgressFlags.fabric) {
            progress.push('fabric');
        }
        if (mask & ProgressFlags.fringe) {
            progress.push('fringe');
        }
        if (mask & ProgressFlags.panel) {
            progress.push('panel');
        }
        if (mask & ProgressFlags.size) {
            progress.push('size');
        }
        return progress;
    }
    function bindProgressMask(sketch) {
        var mask = sketch.ProgressMask || 0;
        var offMask = 127 & (~mask);
        var progress = maskToFlags(mask);
        var offProgress = maskToFlags(offMask);
        progress.forEach(function (tab) {
            $("input[type='radio'][value='" + tab + "']").closest('.radio-button').toggleClass('progressed', true);
        });
        offProgress.forEach(function (tab) {
            $("input[type='radio'][value='" + tab + "']").closest('.radio-button').toggleClass('progressed', false);
        });
    }
    function setProgressFlag(sketch, flag, on) {
        var cur = sketch.ProgressMask || 0;
        if (on) {
            sketch.ProgressMask = cur | flag;
        }
        else {
            sketch.ProgressMask = cur & (~flag);
        }
        if (cur !== sketch.ProgressMask) {
            updatePricing(sketch);
        }
    }
    function saveDesignThumbnail(saveUrl, thumbnail, thumbSize) {
        var formData = new FormData();
        formData.append('thumbnail', thumbnail);
        formData.append('thumbSize.Width', "" + thumbSize.Width);
        formData.append('thubmSize.Height', "" + thumbSize.Height);
        analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.save);
        return $.ajax({
            url: saveUrl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false
        });
    }
    exports.saveDesignThumbnail = saveDesignThumbnail;
    function saveDesignThenOpenSummary(postUrl, saveThumbnail, sketch) {
        var currentSketch = _designer.sketch;
        if (currentSketch && currentSketch.RootSketchId) {
            mergeSketchSpec(sketch, _designer.sketch);
        }
        var wallColor = $('input#wallColor[type="hidden"]').val() || sketch.WallColor;
        sketch.WallColor = wallColor;
        if (sketch.Readonly) {
            $.ajax({
                url: "/design/clone/" + sketch.Id,
                type: 'POST',
                dataType: 'json'
            }).then(function (x) {
                navigateToDesignSketch(x);
            });
            return $.Deferred().resolve(sketch);
        }
        var childSaves = [];
        if (sketch.ChildrenSketches && sketch.ChildrenSketches.length) {
            var cur = _designer.sketch.RootSketchId ? $.map(sketch.ChildrenSketches, function (x) { return x.Id === _designer.sketch.Id ? x : undefined; })[0] : null;
            if (cur) {
                cur.WindowPosition = getCurrentWindowPosition(".edit-design-sketch");
            }
            childSaves = $.map(sketch.ChildrenSketches, function (child) {
                return $.ajax({
                    url: "/design/save/" + child.Id,
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({ WindowPosition: child.WindowPosition, progressMask: (child.ProgressMask || 0) & ProgressFlags.position })
                });
            });
        }
        else {
            childSaves = [$.Deferred().resolve(null)];
        }
        return $.when(childSaves)
            .then(function () { return saveDesign(postUrl, saveThumbnail, sketch); })
            .then(function (result) {
            fillDesignSummary(sketch, $('#design_show_summary'));
            showDesignSummary();
            $('.sketch-gallery section a[href="#"] img').attr('src', result.ThumbUrl);
            return result;
        });
    }
    exports.saveDesignThenOpenSummary = saveDesignThenOpenSummary;
    function deleteSketch(e) {
        e.stopPropagation();
        e.preventDefault();
        var $row = $(e.currentTarget).parent();
        var designId = $row.attr('id');
        if (designId.startsWith('design_')) {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit["delete"]);
            var id = designId.substr(7);
            if (confirm("Okay to delete your design sketch " + id + "?")) {
                analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.deleteConfirm);
                $.ajax({
                    url: "/design/delete/" + id,
                    type: 'DELETE'
                }).then(function () {
                    $row.remove();
                });
            }
        }
    }
    exports.deleteSketch = deleteSketch;
    function saveDesign(postUrl, saveThumbnail, sketch) {
        var WindowPosition = getCurrentWindowPosition(".edit-design-sketch");
        var spec = sketch ? getDefaultCurtainSpec(sketch) : null;
        var extraParams = [];
        if (sketch && sketch.SpecifiedWidth) {
            extraParams.push("sWidth=" + sketch.SpecifiedWidth);
        }
        if (sketch && sketch.SpecifiedHeight) {
            extraParams.push("sHeight=" + sketch.SpecifiedHeight);
        }
        if (sketch && sketch.ProgressMask) {
            extraParams.push("progressMask=" + sketch.ProgressMask);
        }
        if (sketch && sketch.Id !== _designer.sketch.Id) {
            WindowPosition = sketch.WindowPosition;
        }
        if (sketch && sketch.WallColor) {
            extraParams.push("wallColor=" + encodeURIComponent(sketch.WallColor));
        }
        var query = "" + (spec ? simpleSpecToQuery(spec) : '') + (extraParams.length ? [''].concat(extraParams).join('&') : '');
        var result = null;
        progress_1.setState({
            visibility: 'visible',
            className: '',
            label: 'Saving design'
        });
        return $.ajax({
            url: "" + postUrl + query,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(WindowPosition)
        }).then(function (r) {
            result = r;
            return saveDesignThumbnail ? getDesignThumbnail($('.edit-design-sketch .img-box')) : $.Deferred().resolve(null);
        }).then(function (canvas) {
            if (canvas && !_designer.sketch.RootSketchId) {
                var file = canvas_1.canvasToJpegFile(canvas, images_1.ThumbSize.Width, images_1.ThumbSize.Height);
                if (file) {
                    return saveThumbnail(file, { Width: canvas.width, Height: canvas.height });
                }
            }
            var r = $.Deferred();
            r.resolve(result);
            return r;
        }).always(function () {
            progress_1.setState({
                visibility: 'hidden',
                className: 'fade',
                label: 'Saved'
            });
        });
    }
    function ensurePerspectiveSet() {
        if (!perspectiveSet) {
            renderCustomValance_1.setPerspectiveTransform(glfx_1.perspectiveTransform);
            perspectiveSet = true;
        }
    }
    function simpleSpecToQuery(spec) {
        var col = {};
        if (spec.style) {
            col['styleIndex'] = "" + spec.style;
            if (spec.fabricMain) {
                col['fabricId'] = "" + spec.fabricId;
                col['fabricCodeName'] = "" + spec.fabricMain;
                col['fabricGrade'] = "" + getSpecFabricGrade(spec);
            }
            if (spec.fringeStyle) {
                col['fringeStyle'] = "" + spec.fringeStyle;
                col['hasFringe'] = '1';
                col['fringeColor'] = "" + spec.fringeStyle;
            }
            else {
                col['hasFringe'] = '0';
                col['fringeColor'] = '0';
            }
            if (!isNaN(spec.productType)) {
                col['productType'] = "" + spec.productType;
            }
            if (!isNaN(spec.panelHeading)) {
                col['panelHeading'] = "" + spec.panelHeading;
            }
            if (!isNaN(spec.width)) {
                col['width'] = "" + spec.width;
            }
            if (!isNaN(spec.height)) {
                col['height'] = "" + spec.height;
            }
        }
        return querystring_1.formatQuery(col);
    }
    function handleDetailsBarTitle($sel) {
        var $title = $sel.closest('.details-bar').find('.detail-title');
        var $selected = slideSelect_1.getSelected($sel);
        $title.find('span').text($selected.find('label').text());
    }
    exports.handleDetailsBarTitle = handleDetailsBarTitle;
    function filterFringeByStyleIndex($styles, $fringes) {
        var $style = slideSelect_1.getSelected($styles);
        var fringeMasks = ($style.data('fringeMask') || $style.data('fringemask') || '').split(',');
        $fringes.find('>li').each(function (i, li) {
            var $li = $(li);
            var tags = ($li.data('tags') || '').split(',');
            var fringeTags = tags.filter(function (t) { return t.indexOf('fringeStyle_') < 0; });
            var applicable = fringeTags.length === 0 || fringeMasks.length && assetFilter_1.overlaps(fringeTags, fringeMasks);
            $li.toggleClass('hidden', !applicable);
        });
    }
    exports.filterFringeByStyleIndex = filterFringeByStyleIndex;
    function toggleWindowBoxWithScale($svg, show, sketch, sizing) {
        var $box = $svg.closest('.img-box');
        $box.toggleClass('position', show);
        $('.float-bar.top-bar').toggleClass('position', show);
        svg_1.toggleWindowBox($svg, show);
        setWindowPosition($svg, $box, sketch.WindowPosition, sizing);
    }
    function prepareCartImage(spec) {
        var fullSpec = renderCustomValance_1.complete_custom_parameters(spec);
        return renderCustomValance_1.loadAndRenderFullSpec(fullSpec, false, false)
            .then(function (curtain) {
            var canvas = document.createElement('canvas');
            canvas.setAttribute('width', '480');
            canvas.setAttribute('height', '480');
            var painter = new canvas_1.CanvasPainter(canvas);
            painter.reset().setBackgroundColor('#d7d7d7').drawPictureInside(curtain);
            return canvas_1.canvasToJpegFile(canvas);
        });
    }
    function addDesignSketchToCart(postUrl, sketch) {
        if (isDesignSketchQuotable(sketch)) {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.summary.addToCart);
            var spec_3 = getDefaultCurtainSpec(sketch);
            var query = simpleSpecToQuery(spec_3) + "&sketchId=" + sketch.Id;
            var postData_1 = { add_to_cart_formula_0: query };
            var checkSave = null;
            if (!sketch.DesignParametersAsQuery && !sketch.Readonly) {
                var saveThumb = saveDesignThumbnail.bind(null, "/design/UpdateDesignThumbnail/" + sketch.Id);
                checkSave = saveDesign("/design/Save/" + sketch.Id, saveThumb, sketch);
            }
            else {
                checkSave = $.Deferred().resolve(null);
            }
            checkSave.then(function () {
                return priceFormula_1.addFormulaProductToCart(postUrl, postData_1, function () {
                    return prepareCartImage(spec_3);
                });
            }).then(function () {
                hideDesignSummary();
            });
        }
    }
    exports.addDesignSketchToCart = addDesignSketchToCart;
    function disableDetailsBar($editor, forVal, enabled) {
        var $details = $editor.find(".details-bar[data-for=\"" + forVal + "\"]");
        var $input = $editor.find("input[name=\"detail-bar\"][value=\"" + forVal + "\"]");
        var $detail = $input.closest('.radio-button');
        if ($details.hasClass('disabled') === enabled) {
            $details.toggleClass('disabled', !enabled);
            $detail.toggleClass('hidden', !enabled);
            if (!enabled) {
                $details.toggleClass('hidden', !enabled);
            }
        }
    }
    function isDetailsEnabled($editor, forVal) {
        var $details = $editor.find(".details-bar[data-for=\"" + forVal + "\"]");
        return !$details.hasClass('disabled');
    }
    function maskProductTypeFromStyle(sketch) {
        var $style = $("#design_style_select li[data-decimal=\"" + sketch.style + "\"]");
        var productMasks = $style.data('productMask') || $style.data('productmask');
        var productMasksValues = productMasks.split(',').map(function (x) { return renderCustomValance_1.ProductType[x]; });
        $('#design_product_select button').prop('disabled', true);
        $.each(productMasksValues, function (i, productType) {
            $("#design_product_select button[data-decimal=\"" + productType + "\"]").prop('disabled', false);
        });
    }
    exports.maskProductTypeFromStyle = maskProductTypeFromStyle;
    function discardEdit(url) {
        analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.back);
        window.location.href = url;
    }
    exports.discardEdit = discardEdit;
    function showDesignSummary() {
        if (!$('#design_show_price').hasClass('expanded')) {
            $('#design_show_price').toggleClass('expanded', true);
        }
        var $summary = $('#design_show_summary');
        if ($summary.hasClass('closed')) {
            $summary.toggleClass('closed', false);
            modal_1.asModal($summary).then(function () {
                hideDesignSummary();
            });
        }
    }
    function hideDetailBar() {
        var cur = radioList_1.radioCurrent('detail-bar');
        if (cur) {
            radioList_1.radioCurrent('detail-bar', null);
        }
    }
    function hideDesignSummary() {
        if ($('#design_show_price').hasClass('expanded')) {
            $('#design_show_price').toggleClass('expanded', false);
        }
        if (!$('#design_show_summary').hasClass('closed')) {
            $('#design_show_summary').toggleClass('closed', true);
        }
    }
    function bindSketchBackground() {
        var handler = function (e) {
            if ($(e.target).attr('draggable')) {
                return false;
            }
            hideDetailBar();
            hideDesignSummary();
        };
        $('.upload-sketch').off('click').on('click', handler);
    }
    function getCurrentDetailsBar() {
        return $('.details-bar:not(.hidden)').filter(function (i, x) { return !$(x).closest('.sketch-edit').hasClass('hidden'); });
    }
    function getPreviousDetailsBar($bar) {
        return $bar.prev('.details-bar');
    }
    function getNextDetailsBar($bar) {
        return $bar.next('.details-bar');
    }
    function activateDetailsBar($bar) {
        var radioName = $bar.data('radio');
        radioList_1.radioCurrent(radioName, $bar.data('for'));
        var sync = $bar.data('sync');
        if (sync) {
            syncPrevNextLinks();
        }
    }
    function syncPrevNextLinks() {
        var cur = getCurrentDetailsBar();
        var prev = getPreviousDetailsBar(cur);
        var next = getNextDetailsBar(cur);
        $('.edit-form .float-bar a.prev').toggleClass('disabled', prev.length === 0 || prev.hasClass('disabled'));
        $('.edit-form .float-bar a.next').toggleClass('disabled', next.length === 0 && !cur.data('fall-through') || next.hasClass('disabled'));
    }
    function gotoPrevDetailsBar() {
        var cur = getCurrentDetailsBar();
        var prev = getPreviousDetailsBar(cur);
        if (prev.length && !prev.hasClass('disabled')) {
            activateDetailsBar(prev);
        }
    }
    function gotoNextDetailsBar() {
        var cur = getCurrentDetailsBar();
        var next = getNextDetailsBar(cur);
        if (next.length) {
            activateDetailsBar(next);
        }
        else {
            var fallThrough = cur.data('fall-through');
            if (fallThrough) {
                $(fallThrough).click();
            }
        }
    }
    function bindPrevNextLinks() {
        $('.edit-form .float-bar a.prev').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.prev);
            gotoPrevDetailsBar();
        });
        $('.edit-form .float-bar a.next').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit.next);
            gotoNextDetailsBar();
        });
    }
    var fabricFilterOptions = {
        sel: '#design_fabric_select >li',
        choiceIdPrefix: 'design',
        getAssetGrade: function (x) { return x.data('grade'); },
        getAssetId: function (x) { return x.data('decimal'); },
        getSortedBox: function (x) { return x; },
        getSortedList: function ($dlg) { return $dlg.find('#design_fabric_select'); }
    };
    function isRootSketch(sketch) {
        return !sketch.RootSketchId;
    }
    function initializeDesignEditor($editor, sketch, $floatBar, img, formulaApi, extraDiscount, discountCode) {
        var query = querystring_1.parseQuery(sketch.DesignParametersAsQuery);
        var styleIndex = parseInt(query['styleIndex']);
        var fabricId = parseInt(query['fabricId']);
        var fabricCode = query['fabricCodeName'];
        var fringeStyle = parseInt(query['fringeStyle']);
        var productType = parseInt(query['productType']);
        var panelHeading = parseInt(query['panelHeading']);
        var specifiedWidth = sketch.SpecifiedWidth;
        var SpecifiedHeight = sketch.SpecifiedHeight;
        var width = specifiedWidth || parseInt(query['width']);
        var height = SpecifiedHeight || parseInt(query['height']);
        var result = $.Deferred();
        formulaApiUrl = formulaApi;
        priceFormula_1.setDiscountPercentage(extraDiscount / 100.0);
        if (context_1["default"].isMobile()) {
            var $wrapper = $('.master-wrapper-design');
            var viewportHeight = window.innerHeight;
            $wrapper.height(viewportHeight);
            $wrapper.find('.sketch-gallery').height(viewportHeight - 64);
        }
        if (!isNaN(productType)) {
            sketch.productType = productType;
        }
        else {
            sketch.productType = renderCustomValance_1.ProductTypes.FullSet;
        }
        if (!isNaN(styleIndex)) {
            sketch.style = styleIndex;
        }
        else {
            sketch.style = 1;
        }
        if (fabricId) {
            sketch.fabricId = fabricId;
        }
        if (fabricCode) {
            sketch.fabricMain = fabricCode;
        }
        if (!isNaN(fringeStyle)) {
            sketch.fringeStyle = fringeStyle;
        }
        if (!isNaN(panelHeading)) {
            sketch.panelHeading = panelHeading;
        }
        if (!isNaN(width)) {
            sketch.width = width;
        }
        else {
            sketch.width = 100;
        }
        if (!isNaN(height)) {
            sketch.height = height;
        }
        else {
            sketch.height = 96;
        }
        if (sketch.SpecifiedWidth) {
            $('#design_width').val(sketch.SpecifiedWidth);
        }
        if (sketch.SpecifiedHeight) {
            $('#design_height').val(sketch.SpecifiedHeight);
        }
        if (!sketch.DesignParametersAsQuery) {
            if (!sketch.SpecifiedWidth) {
                $('#design_width').val(sketch.width);
            }
            if (!sketch.SpecifiedHeight) {
                $('#design_height').val(sketch.height);
            }
        }
        if (sketch.style) {
            handleProductTypeChange(sketch);
            result = updateStyle(img, sketch);
            slideSelect_1.setRadioSelect($('#design_style_select'), sketch.style);
            if (sketch.fabricId) {
                slideSelect_1.setRadioSelect($('#design_fabric_select'), sketch.fabricId);
            }
            if (!isNaN(sketch.fringeStyle)) {
                slideSelect_1.setRadioSelectByTag($('#design_fringe_select'), "fringeStyle_" + sketch.fringeStyle);
            }
            if (sketch.productType === renderCustomValance_1.ProductTypes.ValanceOnly) {
                slideSelect_1.setRadioSelectByTag($('#design_panel_select'), 'panelStyle_0');
            }
            else if (!isNaN(panelHeading)) {
                slideSelect_1.setRadioSelectByTag($('#design_panel_select'), "panelHeading_" + panelHeading);
            }
            filterFringeByStyleIndex($('#design_style_select'), $('#design_fringe_select'));
        }
        else {
            result = updateStyle(img, sketch);
        }
        var showWindowBox = shouldShowWindowBox(sketch);
        var $svg = $editor.find('#edit-sketch-window-box-svg');
        toggleWindowBoxWithScale($svg, showWindowBox, sketch, showWindowBox);
        radioList_1.radioButtons($floatBar.find('.radio-button button'));
        var $radios = $floatBar.find('input[type="radio"]');
        setProgressFlag(sketch, ProgressFlags.size, !!(sketch.SpecifiedHeight && sketch.SpecifiedWidth));
        bindProgressMask(sketch);
        radioList_1.radioList($('#design_product_select'), function ($opt) {
            sketch.productType = $opt.data('decimal');
            handleProductTypeChange(sketch);
            updateStyle(img, sketch);
        });
        $("#design_product_select button[data-decimal=\"" + (sketch.productType || renderCustomValance_1.ProductType.FullSet) + "\"]").toggleClass('selected', true);
        if ($radios.length) {
            $radios.off('change').on('change', function (e) {
                var $cur = $(e.currentTarget);
                var cur = $cur.val();
                var positioning = cur === 'position' && $cur.is(':checked');
                if (cur !== 'size') {
                    setProgressFlag(sketch, ProgressFlags[cur], true);
                }
                else {
                    var defaultCurtain = getDefaultCurtainSize(defaultRootSpec($('#windowCanvas')[0]));
                    var width_1 = sketch.SpecifiedWidth || sketch.width || defaultCurtain.Width;
                    var height_1 = sketch.SpecifiedHeight || sketch.height || defaultCurtain.Height;
                    $('#design_width[type="hidden"]').val(width_1).data('decimal', width_1);
                    $('#design_height[type="hidden"]').val(height_1).data('decimal', height_1);
                }
                analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.edit[cur][$cur.is(':checked') ? 'open' : 'close']);
                setProgressFlag(sketch, ProgressFlags.size, !!(sketch.SpecifiedHeight && sketch.SpecifiedWidth));
                bindProgressMask(sketch);
                var sizing = cur === 'size' && $cur.is(':checked') && !isRootSketch(sketch) || positioning;
                toggleWindowBoxWithScale($svg, positioning, sketch, sizing);
                if (context_1["default"].isMobile()) {
                    $('.sketchShow .upload-sketch').touchSlider('freeze', positioning);
                }
                if (cur === 'size') {
                    var $radio = $('input[type="radio"][name="designSizeEdit"]:checked');
                    if (!$radio.length) {
                        $radio = $('input[type="radio"][name="designSizeEdit"][value="design_width"]');
                        $radio.prop('checked', 'checked');
                        $radio.trigger('change');
                        $radio.next('label').trigger('click');
                    }
                }
                $svg.closest('.img-box').toggleClass('position', sizing);
                var $detailsBars = $floatBar.nextAll('.details-bar');
                if (cur) {
                    var $prev = $floatBar.nextAll('.details-bar:not(".hidden")');
                    var $next = $floatBar.nextAll('.details-bar[data-for="' + cur + '"]');
                    if ($prev.data('for') !== cur) {
                        $next.toggleClass('hidden', false);
                        slideSelect_1.ensureSelectedInView($next);
                        $prev.toggleClass('hidden', true);
                    }
                    else if (!radioList_1.radioCurrent('detail-bar')) {
                        $prev.toggleClass('hidden', true);
                    }
                }
                else {
                    $detailsBars.toggleClass('hidden', true);
                }
                syncPrevNextLinks();
            });
        }
        if (showWindowBox) {
            radioList_1.radioCurrent('detail-bar', 'position');
            sketch.ProgressMask = (sketch.ProgressMask || 0) | ProgressFlags.position;
        }
        else {
            var cur = radioList_1.radioCurrent('detail-bar');
            if (cur) {
                var $details = $editor.find(".details-bar[data-for=\"" + cur + "\"]");
                if (!$details.hasClass('disabled')) {
                    radioList_1.radioCurrent('detail-bar', cur);
                }
                else {
                    radioList_1.radioCurrent('detail-bar', null);
                    $details.toggleClass('hidden', true);
                }
            }
            else {
                if ((sketch.ProgressMask ^ ProgressFlags.position) === 0) {
                    radioList_1.radioCurrent('detail-bar', 'style');
                }
            }
        }
        filterFringeByStyleIndex($('#design_style_select'), $('#design_fringe_select'));
        bindCurtainSize(img, $('.design-edit-size'), sketch);
        bindCurtainPrice(sketch, $('#design_show_price'));
        bindSketchBackground();
        bindPrevNextLinks();
        syncPrevNextLinks();
        var roomCanvas = $editor.find('#roomCanvas')[0];
        bindWallColor($editor.find('.color-section'), roomCanvas, function () {
            return defaultRootSpec(roomCanvas, _designer.getFullSpec());
        });
        if (sketch.WallColor) {
            $('input#wallColor[type="hidden"]').val(sketch.WallColor);
        }
        var $filterables = $('#design_fabric_select').parent();
        assetFilter_1.setupFilter($filterables, __assign({}, fabricFilterOptions, { $filerStatus: $filterables.find('.action-bar') }));
        if (discountCode) {
            $('#extra_discount_code').text("(with code " + discountCode + ")");
        }
        else {
            $('#extra_discount_code').toggleClass('hidden', true);
        }
        if ((sketch.SpecifiedWidth || sketch.SpecifiedHeight || !sketch.DesignParametersAsQuery) && isRootSketch(sketch)) {
            $('#design_width').trigger('change');
        }
        return result;
    }
    exports.initializeDesignEditor = initializeDesignEditor;
    function bindWallColor($picker, canvas, spec) {
        $picker.find('.color-picker > div').off('click').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            var color = $(e.currentTarget).data('rgb');
            $('input#wallColor[type="hidden"]').val(color);
            updateRoomCanvas(canvas, spec);
        });
    }
    function adjustRoomCanvasSize(canvas, fit) {
        var canvasWidth = fit.canvasWidth, canvasHeight = fit.canvasHeight;
        var $canvas = $(canvas);
        var roomChanged = false;
        if (canvasHeight !== parseInt($canvas.attr('containingHeight'))) {
            $canvas.attr('containingHeight', canvasHeight);
            roomChanged = true;
        }
        if (canvasWidth !== parseInt($canvas.attr('containingWidth'))) {
            $canvas.attr('containingWidth', canvasWidth);
            roomChanged = true;
        }
        return roomChanged;
    }
    function updateRoomCanvas(canvas, spec) {
        var wallColorHex = $('input#wallColor[type="hidden"]').val();
        var fullSpec = spec();
        var roomSpec = renderCustomValance_1.computeRoomSpecFrom(fullSpec);
        var canvasFit = renderCustomValance_1.computeRoomCanvasSpecFrom(roomSpec);
        var $canvas = $(canvas);
        var roomChanged = adjustRoomCanvasSize(canvas, canvasFit);
        return renderCustomValance_1.drawRoom(canvas, __assign({}, fullSpec, { wallColorHex: wallColorHex })).pending.then(function () {
            if (roomChanged && _designer) {
                _designer.redrawCurtain();
            }
        });
    }
    function bindCreateSketchPosition($svg, fullSpec, canvas, fit, onCurtainPosition) {
        $svg
            .off('resize:end')
            .on('resize:end', function () {
            var position = getCurrentWindowPosition('.create-sketch-edit');
            var wallHeight = fullSpec.windowHeight + fullSpec.windowBottom2Floor + fullSpec.windowTop2Ceiling;
            var wallWidth = fullSpec.windowWidth + fullSpec.windowLeftMargin + fullSpec.windowRightMargin;
            var wallTop = (fit.fitHeight - wallHeight) * 0.4;
            var wallBottom = wallTop + wallHeight;
            var wallLeft = (fit.fitWidth - wallWidth) / 2;
            var wallRight = fit.fitWidth - wallLeft;
            var canvasWidth = fit.canvasWidth;
            var canvasHeight = fit.canvasHeight;
            var fitWidth = fit.fitWidth;
            var fitHeight = fit.fitHeight;
            renderCustomValance_1.drawWindowFrame(canvas, __assign({}, fullSpec, { width: fitWidth, height: fitHeight, windowWidth: getRectangleWidth(position) * fitWidth / canvasWidth, windowHeight: getRectangleHeight(position) * fitHeight / canvasHeight, windowLeftMargin: getRectangleLeft(position) * fitWidth / canvasWidth - wallLeft, windowRightMargin: wallRight - getRectangleRight(position) * fitWidth / canvasWidth, windowTop2Ceiling: getRectangleTop(position) * fitHeight / canvasHeight - wallTop, windowBottom2Floor: wallBottom - getRectangleBottom(position) * fitHeight / canvasHeight }))
                .then(function (spec) {
                var curtainPosition = getCurtainPosition(spec, fit);
                if (onCurtainPosition) {
                    onCurtainPosition(curtainPosition);
                }
            });
        });
    }
    function getDefaultCurtainSize(room) {
        return {
            Height: room.wallBottom - (room.wallTop + room.windowTop2Ceiling - 4),
            Width: room.windowWidth + 12
        };
    }
    function getCurtainPosition(room, fit) {
        var wallWidth = room.wallRight - room.wallLeft;
        var margin = (wallWidth - room.windowWidth - 12) / 2;
        var curtainPos = {
            top: Math.max(0, room.wallTop + room.windowTop2Ceiling),
            bottom: room.wallBottom,
            left: room.wallLeft + margin,
            right: room.wallRight - margin
        };
        var top = Math.round(curtainPos.top / fit.fitHeight * fit.canvasHeight);
        var bottom = Math.round(curtainPos.bottom / fit.fitHeight * fit.canvasHeight);
        var left = Math.round(curtainPos.left / fit.fitWidth * fit.canvasWidth);
        var right = Math.round(curtainPos.right / fit.fitWidth * fit.canvasWidth);
        return {
            topLeft: { X: left, Y: top },
            topRight: { X: right, Y: top },
            bottomLeft: { X: left, Y: bottom },
            bottomRight: { X: right, Y: bottom }
        };
    }
    var defaultSimpleSpec = {
        width: 100,
        height: 96,
        productType: 3,
        style: 1,
        fringeStyle: 0,
        fabricMain: renderCustomValance_1.SKETCH_FABRIC_CODE
    };
    function resizeWindowForCurtainSize(canvas, spec) {
        var curtainWidth = spec.width, curtainHeight = spec.height;
        var rootSpec = defaultRootSpec(canvas, renderCustomValance_1.complete_custom_parameters(spec));
        return __assign({}, renderCustomValance_1.complete_custom_parameters(__assign({}, rootSpec, { windowWidth: curtainWidth - 12 })), object_1.pick(rootSpec, 'windowHeight', 'windowTop2Ceiling', 'windowBottom2Floor', 'windowLeftMargin', 'windowRightMargin', 'setBack'));
    }
    function resizeWindowPositions(fullSpec, canvas) {
        var bounds = {
            x0: 0,
            y0: 0,
            x1: fullSpec.width,
            y1: fullSpec.height,
            expansionMode: 'all'
        };
        var fit = renderCustomValance_1.computeCanvasFit(canvas, bounds);
        var wallHeight = fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor;
        var wallWidth = fullSpec.windowWidth + fullSpec.windowLeftMargin + fullSpec.windowRightMargin;
        var walls = {
            wallTop: (fullSpec.height - wallHeight) * 0.4,
            wallBottom: fit.fitHeight - (fit.fitHeight - wallHeight) * 0.6,
            wallLeft: (fit.fitWidth - wallWidth) / 2,
            wallRight: fit.fitWidth - (fit.fitWidth - wallWidth) / 2,
            setBack: 6,
            maxWidth: fullSpec.width,
            maxHeight: fullSpec.height
        };
        return getCurtainPosition(__assign({}, fullSpec, walls), fit);
    }
    function updateWindowPosition(pos) {
        _designer.resizeWindow(pos);
    }
    function defaultRootSpec(canvas, current) {
        var simpleSpec = __assign({}, defaultSimpleSpec, current);
        var room = renderCustomValance_1.computeRoomSpecFrom(simpleSpec);
        var fullSpec = __assign({}, renderCustomValance_1.complete_custom_parameters(simpleSpec), room);
        return fullSpec;
    }
    function initializeSketchCreator($editor, $floatBar, onCurtainPosition) {
        if (context_1["default"].isMobile()) {
            var $wrapper = $('.master-wrapper-design');
            $wrapper.height(window.innerHeight);
        }
        var $canvas = $editor.find('#roomCanvas');
        var windowCanvas = $editor.find('#windowCanvas')[0];
        var $svg = $('#create-sketch-window-box-svg');
        var roomCanvas = $canvas[0];
        var fullSpec = __assign({ wallColor: renderCustomValance_1.WallColor.BlueArrow }, defaultRootSpec(roomCanvas));
        var roomSpec = renderCustomValance_1.computeRoomSpecFrom(fullSpec);
        var roomFit = renderCustomValance_1.computeRoomCanvasSpecFrom(roomSpec);
        adjustRoomCanvasSize(roomCanvas, roomFit);
        var fit = renderCustomValance_1.drawRoom(roomCanvas, fullSpec);
        paintColors_1.renderAllColors($('.details-bar[data-for="color"]'), '');
        bindWallColor($editor.find('.color-section'), $canvas[0], function () { return fullSpec; });
        bindCreateSketchPosition($svg, fullSpec, windowCanvas, fit, onCurtainPosition);
        bindDetailsContinueButtons();
        bindPrevNextLinks();
        var $radios = $floatBar.find('input[type="radio"]');
        if ($radios.length) {
            $svg.data('rectangular', true);
            var windowBoundBox = fitBoundingBox({ Width: fit.fitWidth, Height: fit.fitHeight }, images_1.DesignSize);
            setDefaultWindowPosition($svg, $editor.find('.img-box'), windowBoundBox, __assign({}, fullSpec, { maxHeight: fit.fitHeight, maxWidth: fit.fitWidth }));
            $svg.trigger('resize:end');
            $radios.on('change', function (e) {
                var cur = radioList_1.radioCurrent('create-sketch-detail-bar');
                var $prev = $floatBar.nextAll('.details-bar:not(".hidden")');
                if (cur) {
                    var $next = $floatBar.nextAll(".details-bar[data-for=\"" + cur + "\"]");
                    $next.toggleClass('hidden', false);
                }
                svg_1.toggleWindowBox($svg, cur === 'position');
                $prev.toggleClass('hidden', true);
            });
            radioList_1.radioCurrent('create-sketch-detail-bar', 'color');
            radioList_1.radioButtons($floatBar.find('.radio-button button'));
        }
    }
    exports.initializeSketchCreator = initializeSketchCreator;
    function transitionToDesign(sketch) {
        window.history.replaceState({}, "", "/design/edit/" + sketch.Id);
        $('.sketch-edit.create-sketch-edit').toggleClass('hidden', true);
        var $box = $('.edit-design-sketch .img-box');
        var $svg = $box.find('svg');
        var $img = $($box.find('img')[0]);
        afterImageReady($img, function () { return onDesignLoaded($svg, $box, sketch, undefined); });
        $img.attr('src', sketch.PhotoUrl);
        $('.sketch-edit.edit-design-sketch').toggleClass('hidden', false);
    }
    function createSketch(getCurtainPos) {
        var canvasSketch = $('.upload-sketch.create-sketch').is(':visible');
        if (canvasSketch) {
            var position = getCurtainPos ? getCurtainPos() : null;
            position = position || getCurrentWindowPosition('.create-sketch-edit');
            var wallColor = $('input#wallColor[type="hidden"]').val();
            var img = $('.create-sketch #roomCanvas')[0];
            images_1.uploadImageFiles($(img), '/design/postPhotos', position, wallColor, ProgressFlags.position)
                .then(function (x) {
                var _a;
                var sketch = x;
                sketchMap = (_a = {}, _a["" + sketch.Id] = sketch, _a);
                var $gallery = $('.sketch-gallery');
                $gallery.find('section a:first-child img').attr('src', sketch.ThumbUrl);
                transitionToDesign(sketch);
            });
        }
    }
    exports.createSketch = createSketch;
    function transitionToChildSketch(sketch, childSketchId) {
        var matchedSketches = (sketch.ChildrenSketches || []).filter(function (x) { return x.Id === childSketchId; });
        var childSketch = matchedSketches.length ? matchedSketches[0] : null;
        if (!childSketch) {
            return;
        }
        var progressMask = childSketch.ProgressMask | (sketch.ProgressMask ^ ProgressFlags.position);
        var mergedSketch = __assign({}, sketch, object_1.pick(childSketch, "WindowPosition", "PhotoUrl", "ThumbUrl", "PhotoSize", "ThumbSize", "WallColor", "Id", "RootSketchId"), object_1.pick(sketch, 'CustomerId', 'ProgressMask'), { ProgressMask: progressMask, DesignParametersAsQuery: simpleSpecToQuery(sketch) });
        _designer.switchSketch(mergedSketch);
        childSketch.ProgressMask = (childSketch.ProgressMask || 0) | ProgressFlags.position;
    }
    exports.transitionToChildSketch = transitionToChildSketch;
    function mergeSketchSpec(sketch, from) {
        object_1.merge(sketch, from, 'fabricId', 'fabricMain', 'fringeStyle', 'height', 'width', 'windowWidth', 'style', 'productType', 'SpecifiedHeight', 'SpecifiedWidth');
        sketch.DesignParametersAsQuery = simpleSpecToQuery(_designer.sketch);
    }
    function bindSketchGallery(sketch, $gallery) {
        $gallery.off('click', 'a').on('click', 'a', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $link = $(e.currentTarget);
            var href = $link.attr('href');
            var prevId = _designer.sketch.Id;
            var prevSketch = prevId === sketch.Id ? sketch : sketch.ChildrenSketches.filter(function (x) { return x.Id === prevId; })[0];
            prevSketch.WindowPosition = _designer.sketch.WindowPosition;
            if (href.startsWith('#child/')) {
                var childSketchId = parseInt(href.substr(7));
                transitionToChildSketch(sketch, childSketchId);
            }
            else if (href === '#') {
                mergeSketchSpec(sketch, _designer.sketch);
                _designer.switchSketch(sketch);
            }
        });
        if (context_1["default"].isMobile()) {
            $('.edit-design-sketch .upload-sketch').touchSlider({
                className: 'sketchShow',
                sel: '.img-box',
                width: 480,
                screenWidth: 480,
                speed: 1,
                current: 0,
                gutter: 0,
                disableFullScreen: false,
                onCurrentChange: onGallerySlide.bind(null, sketch)
            });
            $('.sketchShow').off('click').on('click', function () {
                hideDetailBar();
                hideDesignSummary();
            });
        }
    }
    exports.bindSketchGallery = bindSketchGallery;
    function onGallerySlide(sketch, curIndex) {
        var targetSketch = curIndex === 0 ? sketch : (curIndex <= (sketch.ChildrenSketches ? sketch.ChildrenSketches.length : 0) ? sketch.ChildrenSketches[curIndex - 1] : null);
        if (targetSketch == null || _designer.sketch && _designer.sketch.Id === targetSketch.Id) {
            hideDetailBar();
            hideDesignSummary();
            return;
        }
        var $slider = $('.edit-design-sketch .upload-sketch.photo-viewport');
        var $canvas = $slider.find('.canvas-box');
        var $svg = $canvas.nextAll('svg');
        var $mark = $svg.nextAll('.progress-mask:first');
        var $current = $slider.find('>.current.img-box');
        if (_designer.sketch.RootSketchId) {
            var child = (sketch.ChildrenSketches || []).filter(function (x) { return x.Id === _designer.sketch.Id; })[0];
            var WindowPosition = getCurrentWindowPosition('.edit-design-sketch', _designer.getBox());
            object_1.merge(child, { WindowPosition: WindowPosition }, "WindowPosition");
        }
        $canvas.appendTo($current);
        $svg.appendTo($current);
        $mark.appendTo($current);
        _designer.resetNodes($current);
        _designer.sketch.DesignParametersAsQuery = simpleSpecToQuery(_designer.sketch);
        if (targetSketch !== sketch) {
            transitionToChildSketch(sketch, targetSketch.Id);
        }
        else {
            mergeSketchSpec(sketch, _designer.sketch);
            _designer.switchSketch(sketch);
        }
    }
    exports.onGallerySlide = onGallerySlide;
    function appendNewChildSketch(rootSketch, childSketch) {
        rootSketch.ChildrenSketches = (rootSketch.ChildrenSketches || []).concat([childSketch]);
        var $link = $("<a href='#child/" + childSketch.Id + "'><img src='" + childSketch.ThumbUrl + "'/></a>").insertAfter($('.sketch-gallery .sketch-thumbnails > a:last-of-type'));
        var $capture = $('#capturedImage');
        if ($capture.length) {
            $capture.replaceWith("<img src='" + childSketch.PhotoUrl + "' crossorigin='Anonymous'/>");
        }
        if (context_1["default"].isMobile()) {
            var $sketchShow = $('.sketchShow');
            var $last = $sketchShow.find('label[for="photo-sketch"]').closest('.img-box');
            $("<div class=\"img-box current\"><img src='" + childSketch.PhotoUrl + "' crossorigin='Anonymous'/></div>").insertBefore($last);
            $last.toggleClass('current', false);
            var $paging = $sketchShow.find('.paging');
            $paging.data('total', parseInt($paging.data('total')) + 1);
            $sketchShow.find('.upload-sketch').touchSlider('current', rootSketch.ChildrenSketches.length);
        }
        else {
            $link.click();
        }
    }
    exports.appendNewChildSketch = appendNewChildSketch;
    function atZero(p) {
        return p.X === 0 && p.Y === 0;
    }
    function isWindowPositionSet(pos) {
        return pos && !(atZero(pos.topLeft) && atZero(pos.topRight) && atZero(pos.bottomLeft) && atZero(pos.bottomRight));
    }
    exports._designLoadSettings = null;
    var DesignerState;
    (function (DesignerState) {
        DesignerState["loading"] = "loading";
        DesignerState["loaded"] = "loaded";
    })(DesignerState || (DesignerState = {}));
    var SketchDesigner = (function () {
        function SketchDesigner(sketch, settings, $svg, $box, $img) {
            this.sketch = sketch;
            this.settings = settings;
            this.$svg = $svg;
            this.$box = $box;
            this.$img = $img;
            this._state = DesignerState.loading;
        }
        SketchDesigner.prototype.getFullSpec = function () {
            return renderCustomValance_1.complete_custom_parameters(this.sketch);
        };
        SketchDesigner.prototype.resetNodes = function ($div) {
            this.$box = $div.hasClass('img-box') ? $div : $div.find('.img-box');
            this.$svg = this.$box.find('svg');
            this.$img = $(this.$box.find('img')[0]);
        };
        SketchDesigner.prototype.getBox = function () {
            return this.$box;
        };
        SketchDesigner.prototype.onLoaded = function () {
            var _this = this;
            this.setState(DesignerState.loading);
            _onDesignLoaded(this.$svg, this.$box, this.sketch, this.settings)
                .always(function () {
                var $canvas = _this.$box.find('#roomCanvas');
                if (!_this.sketch.RootSketchId) {
                    var wallColor = _this.$box.closest('.sketch-edit').find('input#wallColor[type="hidden"]').val() || _this.sketch.WallColor;
                    var fullSpec = defaultRootSpec($canvas[0]);
                    renderCustomValance_1.drawRoom($canvas[0], __assign({}, fullSpec, { wallColorHex: wallColor }));
                }
                if (!context_1["default"].isMobile()) {
                    if (_this.sketch.RootSketchId) {
                        _this.$box.find('img').toggleClass('hidden', false);
                        $canvas.toggleClass('hidden', true);
                    }
                    else {
                        _this.$box.find('img').toggleClass('hidden', true);
                        $canvas.toggleClass('hidden', false);
                    }
                }
                _this.setState(DesignerState.loaded);
                watchForWindowResize(_this.redrawCurtain.bind(_this));
            });
        };
        SketchDesigner.prototype.redrawCurtain = function () {
            var $img = this.$img || this.$box.find('img:visible, #roomCanvas:visible');
            if ($img.length === 0) {
                $img = this.$box.find('img, #roomCanvas');
            }
            return showCurtainOnSketch(this.sketch, $img[0]).then(function (canvas) {
                var $canvasBox = $img.nextAll('.canvas-box');
                $canvasBox.empty().append(canvas);
            });
        };
        SketchDesigner.prototype.switchSketch = function (sketch) {
            var _this = this;
            if (this.sketch === sketch) {
                return;
            }
            this.setState(DesignerState.loading);
            var $img = $(this.$box.find('img')[0]);
            this.sketch = sketch;
            $img.attr('src', sketch.PhotoUrl);
            afterImageReady($img, function () { _this.onLoaded(); });
        };
        SketchDesigner.prototype.getState = function () {
            return this._state;
        };
        SketchDesigner.prototype.setState = function (to) {
            if (to === this._state) {
                return;
            }
            this._state = to;
            if (to === DesignerState.loading) {
                progress_1.setState({
                    visibility: 'visible',
                    className: '',
                    label: 'loading'
                });
                $('div.canvas-box').hide();
            }
            else {
                progress_1.setState({
                    visibility: 'hidden',
                    className: '',
                    label: 'loaded'
                });
                $('div.canvas-box').show();
            }
        };
        SketchDesigner.prototype.resizeWindow = function (pos) {
            setWindowPosition(this.$svg, this.$box, pos, false, isRootSketch(this.sketch) ? 1 : undefined);
            this.sketch.WindowPosition = pos;
            this.$svg.trigger('resize:end');
        };
        return SketchDesigner;
    }());
    function bindDetailsContinueButtons() {
        $('.details-bar button.continue').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            gotoNextDetailsBar();
        });
    }
    function _onDesignLoaded($svg, $box, sketchModel, settings) {
        settings = __assign({}, exports._designLoadSettings, settings);
        var discount = settings;
        var formulaUri = settings.FormulaUrl;
        var result = null;
        if (isWindowPositionSet(sketchModel.WindowPosition)) {
            setWindowPosition($svg, $box, sketchModel.WindowPosition);
        }
        else {
            setDefaultWindowPosition($svg, $box, sketchModel.PhotoSize);
        }
        var sketch = sketchModel;
        bindWindowPosition($svg, sketch);
        bindDetailsContinueButtons();
        if (!sketch.RootSketchId) {
            var saveThumbnail = saveDesignThumbnail.bind(null, "/design/UpdateDesignThumbnail/" + sketch.Id);
            $('.float-bar #save').unbind('click').click(saveDesignThenOpenSummary.bind(null, "/design/save/" + sketch.Id, saveThumbnail, sketch));
        }
        disableDetailsBar($('.edit-design-sketch'), 'position', !!sketch.RootSketchId);
        disableDetailsBar($('.edit-design-sketch'), 'color', !sketch.RootSketchId);
        var updateDetailsTitle = handleDetailsBarTitle;
        var discountPercentage = 0;
        var discountCode = undefined;
        if (discount != null && discount.DiscountPercentage > 0) {
            discountPercentage = discount.DiscountPercentage;
        }
        if (discount != null && discount.RequiresCouponCode) {
            discountCode = discount.CouponCode;
        }
        var $editor = $svg.closest('.sketch-edit');
        var $img = $editor.find('.current.img-box img');
        if ($img.length === 0) {
            $img = $editor.find('.img-box img');
        }
        var img = $img[0];
        result = initializeDesignEditor($editor, sketch, $editor.find('.float-bar'), img, formulaUri, discountPercentage, discountCode);
        $editor.find('.float-bar #style').off('radioSelect:change').on('radioSelect:change', function (e, styleIndex) {
            sketch.style = styleIndex;
            handleDesignChange(img, sketch, 'style');
            var $styles = $('#design_style_select');
            var $fringes = $('#design_fringe_select');
            updateDetailsTitle($styles);
            maskProductTypeFromStyle(sketch);
            filterFringeByStyleIndex($styles, $fringes);
        });
        $editor.find('.float-bar #fringe').off('radioSelect:change').on('radioSelect:change', function (e, fringeId) {
            var $fringes = $('#design_fringe_select');
            handleFringeChange($fringes, fringeId, sketch, img);
            updateDetailsTitle($('#design_fringe_select'));
        });
        $editor.find('.float-bar #fabric').off('radioSelect:change').on('radioSelect:change', function (e, fabricId) {
            var $fabric = $('#design_fabric_select li[data-decimal="' + fabricId + '"]');
            sketch.fabricId = fabricId;
            sketch.fabricMain = $fabric.data('fabricCode') || $fabric.data('fabriccode');
            handleDesignChange(img, sketch, 'fabric');
            updateDetailsTitle($('#design_fabric_select'));
        });
        $('.float-bar:visible #discard').off('click').click(function () {
            discardEdit("/design#design_" + (sketchModel.RootSketchId || sketchModel.Id));
        });
        $editor.find('input[name="detail-bar"]').on('change', function (e) {
            if (!$('#design_show_summary').hasClass('closed')) {
                $('#design_show_price').toggleClass('expanded', false);
                $('#design_show_summary').toggleClass('closed', true);
            }
            var cur = radioList_1.radioCurrent('detail-bar');
            switch (cur) {
                case 'style':
                    updateDetailsTitle($('#design_style_select'));
                    break;
                case 'fabric':
                    updateDetailsTitle($('#design_fabric_select'));
                    break;
                case 'fringe':
                    updateDetailsTitle($('#design_fringe_select'));
                    break;
                case 'panel':
                    updateDetailsTitle($('#design_panel_select'));
                    break;
            }
        });
        $('#addVariantsToCart').off('click').click(function () {
            addDesignSketchToCart(settings.AddToCartUrl, sketch);
        });
        return result;
    }
    ;
    var _designer = null;
    function onDesignLoaded($svg, $box, sketchModel, settings) {
        _designer = _designer || new SketchDesigner(sketchModel, settings, $svg, $box, undefined);
        _designer.sketch = sketchModel;
        _designer.onLoaded();
        bindSketchGallery(sketchModel, $('.sketch-gallery'));
    }
    exports.onDesignLoaded = onDesignLoaded;
    function watchForWindowResize(action) {
        var resizeTimeout;
        $(window).off('resize').on('resize', function () {
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }
            resizeTimeout = setTimeout(action, 250);
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/design.js
// module id = 23
// module chunks = 0